module.exports = __webpack_public_path__ + "static/media/5.e1bc3a5a.png";